import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { UNIVERSITY_API_ROOT_URL } from '../constants';

export type LibraryFolder = {
  id: string;
  name: string;
  parentUniversityFolderId: string | null;
};
export const GET_LIBRARY_FOLDER_KEY = 'get-library-folder';

const getLibraryFolder = (id: string): Promise<LibraryFolder[]> => {
  const url = `${UNIVERSITY_API_ROOT_URL}/${id}/get_folders_for_university`;
  return FetchPromise.get(`${url}`);
};

export const useGetLibraryFolder = (id: string | null) =>
  useQuery<LibraryFolder[], JQuery.jqXHR>([GET_LIBRARY_FOLDER_KEY, id], () => getLibraryFolder(id), { enabled: !!id });
